import { render, staticRenderFns } from "./Notranslate.vue?vue&type=template&id=f316faec"
import script from "./Notranslate.vue?vue&type=script&lang=js"
export * from "./Notranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports